import React, { useEffect } from "react";
import { CircularProgress } from "../../UI/Progress";

const MSLoginCallBack = ():any => {
    
    const param = new URLSearchParams(window.location.search);
    const getcode = param.get("code");
    useEffect(() => {
       console.log(window.location);
       const channel = new BroadcastChannel("ms-auth-channel");
       channel.postMessage({ code: getcode });
       channel.close();
       window.close(); // Close the child window

      }, []);
    return <CircularProgress />;
};

export default MSLoginCallBack;